import { defineMessages } from "react-intl";
export default defineMessages({
  // Month names
  january: {
    "id": "calendar.january",
    "defaultMessage": "January",
    "description": "Month names"
  },
  february: {
    "id": "calendar.february",
    "defaultMessage": "February"
  },
  march: {
    "id": "calendar.march",
    "defaultMessage": "March"
  },
  april: {
    "id": "calendar.april",
    "defaultMessage": "April"
  },
  may: {
    "id": "calendar.may",
    "defaultMessage": "May"
  },
  june: {
    "id": "calendar.june",
    "defaultMessage": "June"
  },
  july: {
    "id": "calendar.july",
    "defaultMessage": "July"
  },
  august: {
    "id": "calendar.august",
    "defaultMessage": "August"
  },
  september: {
    "id": "calendar.september",
    "defaultMessage": "September"
  },
  october: {
    "id": "calendar.october",
    "defaultMessage": "October"
  },
  november: {
    "id": "calendar.november",
    "defaultMessage": "November"
  },
  december: {
    "id": "calendar.december",
    "defaultMessage": "December"
  },
  // Time periods
  day: {
    "id": "calendar.day",
    "defaultMessage": "Day",
    "description": "Time periods"
  },
  last24Hours: {
    "id": "calendar.last24Hours",
    "defaultMessage": "Last 24 hours"
  },
  week: {
    "id": "calendar.week",
    "defaultMessage": "Week"
  },
  last7Days: {
    "id": "calendar.last7Days",
    "defaultMessage": "Last 7 days"
  },
  month: {
    "id": "calendar.month",
    "defaultMessage": "Month"
  },
  last30Days: {
    "id": "calendar.last30Days",
    "defaultMessage": "Last 30 days"
  },
  months: {
    "id": "calendar.months",
    "defaultMessage": "months"
  },
  year: {
    "id": "calendar.year",
    "defaultMessage": "Year"
  },
  max: {
    "id": "calendar.max",
    "defaultMessage": "Max"
  },
  thirtyMinutes: {
    "id": "calendar.thirtyMinutes",
    "defaultMessage": "30-min"
  },
  oneHour: {
    "id": "calendar.oneHour",
    "defaultMessage": "1-hour"
  },
  threeHours: {
    "id": "calendar.threeHours",
    "defaultMessage": "3-hour"
  },
  sixHours: {
    "id": "calendar.sixHours",
    "defaultMessage": "6-hour"
  },
  oneDay: {
    "id": "calendar.oneDay",
    "defaultMessage": "1-day"
  },
  oneWeek: {
    "id": "calendar.oneWeek",
    "defaultMessage": "1-week"
  },
  oneMonth: {
    "id": "calendar.oneMonth",
    "defaultMessage": "1-month"
  },
  selectTimescale: {
    "id": "calendar.selectTimescale",
    "defaultMessage": "Select a time scale"
  },
  selectGranularity: {
    "id": "calendar.selectGranularity",
    "defaultMessage": "Select a granularity"
  },
  previousDay: {
    "id": "calendar.previousDay",
    "defaultMessage": "Previous day"
  },
  sameDayLastYear: {
    "id": "calendar.sameDayLastYear",
    "defaultMessage": "Same day last year"
  },
  previous24Hours: {
    "id": "calendar.previous24Hours",
    "defaultMessage": "Previous 24 hours"
  },
  previousWeek: {
    "id": "calendar.previousWeek",
    "defaultMessage": "Previous week"
  },
  previous7Days: {
    "id": "calendar.previous7Days",
    "defaultMessage": "Previous 7 days"
  },
  previous30Days: {
    "id": "calendar.previous30Days",
    "defaultMessage": "Previous 30 days"
  },
  previousMonth: {
    "id": "calendar.previousMonth",
    "defaultMessage": "Previous month"
  },
  sameMonthLastYear: {
    "id": "calendar.sameMonthLastYear",
    "defaultMessage": "Same month last year"
  },
  previousYear: {
    "id": "calendar.previousYear",
    "defaultMessage": "Previous year"
  },
  hours: {
    "id": "calendar.hours",
    "defaultMessage": "Hours"
  },
  hoursShort: {
    "id": "calendar.hoursShort",
    "defaultMessage": "hrs"
  },
  use24HourFormat: {
    "id": "calendar.use24HourFormat",
    "defaultMessage": "Use 24-hour format"
  },
  dateFormat: {
    "id": "calendar.dateFormat",
    "defaultMessage": "Date format"
  },
  yesterday: {
    "id": "calendar.yesterday",
    "defaultMessage": "Yesterday"
  },
  start: {
    "id": "calendar.start",
    "defaultMessage": "Start"
  },
  end: {
    "id": "calendar.end",
    "defaultMessage": "End"
  },
  selectADate: {
    "id": "calendar.selectADate",
    "defaultMessage": "Select a date"
  },
  selectAMonth: {
    "id": "calendar.selectAMonth",
    "defaultMessage": "Select a month"
  },
  selectAYear: {
    "id": "calendar.selectAYear",
    "defaultMessage": "Select a year"
  }
});